import React, {FormEvent} from "react";
import '../../styles/components/sign-in/sign-in-page.scss';
import Form from "../common/Form";
import signIn from "../../services/signIn/signIn";
import Button from "../common/Button";
import ExternalLink from "../common/ExternalLink";
import {useSearchParams} from "react-router-dom";

// Import images
import PngSm from "./images/tapping-tablet-on-keyboard-sm.png";
import PngLg from "./images/tapping-tablet-on-keyboard-lg.png";
import WebpSm from "./images/tapping-tablet-on-keyboard-sm.webp";
import WebpLg from "./images/tapping-tablet-on-keyboard-lg.webp";
import AvifSm from "./images/tapping-tablet-on-keyboard-sm.avif";
import AvifLg from "./images/tapping-tablet-on-keyboard-lg.avif";
import {baseUrlForWebsite} from "../../client/PlaygroundSettings";
import {useTrialNavigation} from "../../hooks/trialNavigation.hook";
import {FormFieldTextInput} from "../common/FormFieldTextInput";

export default function SignInPage() {
  const signInForm = signIn.useSignInForm();
  const {isLoading} = signIn.useLoadingHook();
  const [searchParams] = useSearchParams();
  const {navigateToAppropriateAccountCreationPage} = useTrialNavigation();

  const handleFormSignIn = (searchParams: URLSearchParams) => {
    if(!isLoading){
      void signIn.signInUsingSignInForm(searchParams);
    }
  }
  function handleSubmit(e: FormEvent, searchParams: URLSearchParams){
    handleFormSignIn(searchParams);
    e.preventDefault();
  }
  return (
    <div className="sign-in-page">
      <header className="top">
        <picture>
          <source media={"(orientation: portrait)"} srcSet={AvifSm} type={"image/avif"} />
          <source media={"(orientation: portrait)"} srcSet={WebpSm} type={"image/webp"} />
          <source media={"(orientation: portrait)"} srcSet={PngSm} type={"image/png"} />
          <source media={"(orientation: landscape)"} srcSet={AvifLg} type={"image/avif"} />
          <source media={"(orientation: landscape)"} srcSet={WebpLg} type={"image/webp"} />
          <source media={"(orientation: landscape)"} srcSet={PngLg} type={"image/png"} />
          <img src={PngLg} alt="Hand reaching to tap tablet on keyboard" width={740} height={673} className={"image"} />
        </picture>
        <h1 className="overlay-text">Sign in</h1>
      </header>
      <div className={"content-and-navigation"}>
        <div className="content">
          <div className="page-header-text">Sign in</div>
          <Form onSubmit={(e) => handleSubmit(e, searchParams)}>
            <FormFieldTextInput
              autoComplete={"username"}
              inputMode={"email"}
              formField={signInForm.username}
              label={"Username or email address"}
            />
            <FormFieldTextInput
              autoComplete={"current-password"}
              formField={signInForm.password}
              isPassword={true}
              label={"Password"}
            />
            <ExternalLink
              url={`${baseUrlForWebsite}/login/forgot-password`}
              title={"Forgot password?"}
            />
            <Button
              isLoading={isLoading}
              buttonType={"secondary"}
              onClick={() => handleFormSignIn(searchParams)}
              text={"Sign In"}
              navigationNote={"D"}
            />
          </Form>
        </div>
        <div className="navigation">
          <div className="text-and-button">
            <div className="text">Don&apos;t have an account yet?</div>
            <Button
              text={"Create Account"}
              onClick={()=> navigateToAppropriateAccountCreationPage()}
              navigationNote={"C"}
              buttonType={"primary"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}